<template>
    <svg aria-hidden="true" focusable="false" v-if="size === 'small'" class="add small" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.85" cx="17" cy="17" r="16.5" fill="transparent" stroke="#9D9FA2" />
        <g class="cross">
            <path d="M11 17H23" stroke="currentColor" stroke-linecap="round" />
            <path d="M17 23L17 11" stroke="currentColor" stroke-linecap="round" />
        </g>
    </svg>

    <svg aria-hidden="true" focusable="false" v-else class="add large" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.5" cy="22.5" r="22" fill="transparent" stroke="#9D9FA2" />
        <path d="M14.5588 22.5H30.4412" stroke="currentColor" stroke-linecap="round" />
        <path d="M22.5 30.4412L22.5 14.5588" stroke="currentColor" stroke-linecap="round" />
    </svg>
</template>

<script setup>
    const props = defineProps({
        size: {
            type: String,
            required: false,
            default: 'small',
        },
    });
</script>

<style lang="scss" scoped>
    .add .cross {
        transform-origin: center;
        transform: rotate(0);
        transition: transform 0.25s ease-in-out;
    }

    .in-itinerary {
        .add .cross {
            transform: rotate(45deg);
            transition: transform 0.25s ease-in-out;
        }
    }
</style>
